module.exports = __webpack_public_path__ + "img/aushopping-logo.00702b70.png";